import gql from 'graphql-tag'

export default gql`
  query RequirementTypes($workflowId: ID!) {
    requirementTypes(workflowId: $workflowId) {
      id
      slot
      title
      description
      color {
        red
        green
        blue
        rgb
      }
      showInBacklog
      generateWithAI
      triggerType
      queryType
      aggregateType
      defaultType
      order
    }
  }
`
